import React from "react";
import { useState } from "react";
import "./Register.css";
import swal from 'sweetalert';
import 
    SignUp
 from '../api/index';

const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';



const Register = (props) => {
  const [username, setCurrentUsername] = useState("");
  const [password, setCurrentPassword] = useState("");
  
  const {user, setUser} = props;
  return (
    <>
    <div className="sign-up">
      <span><b>Enter an email address and new password to Sign-up. <i>Password must be atleast 8 characters.</i></b></span>
      <form id="sign-up-form">
        username&nbsp;<input type="text" value ={username} placeholder="username" onChange={(event )=> {
            event.preventDefault();
            let username = event.target.value;
            
            
            return setCurrentUsername(username);    
        }}></input>
        password&nbsp;
        <input
          type="text"
          value={password}
          onChange={(event) => {
            event.preventDefault();
            let password = event.target.value;
            
            return setCurrentPassword(password);
          }}
          placeholder="password"
        ></input>
      </form>

      <button
        id="submit-info"
        value={password}
        onClick={ async (event)=> {
            event.preventDefault();
            try {
                const response = await SignUp(username, password)
                swal(`Thank you for signing up ${response.user.username}!`, "Log in to continue!", "success");
                if(response) localStorage.setItem('user', JSON.stringify(response.token));
                setUser(response.user)
                
                
                return user;
            } catch (error) {
                console.error(error);
            } finally {
              
            }
        }}
      >
      REGISTER
      </button>
      { password.length < 8 ? <><b><i><span>&nbsp;&nbsp;Password too short (8 or more)
        </span></i></b></> : ''}
    </div>
    </>
  );
};

export default Register;
